<template>
  <div class="main download">
    <div class="banner">
    </div>
    <div class="mainContent">
      <div class="home-part">
        <!--<div class="home-info">-->
        <!--<p class="home-title title">{{ $t('download-title') }}</p>-->
        <!--</div>-->
        <div class="small-screen">
          <p class="home-title title">{{ $t('home-download-title1') }}</p>
          <div class="line"></div>
        </div>
        <img class="multi-device" src="../assets/images/20180815/mockup.png" alt="">
        <!--<div class="home-intro">-->
        <!--<p class="home-intro-detail">{{ $t('download-detail') }}</p>-->
        <!--</div>-->
        <div class="home-download">
          <p class="home-title title">{{ $t('home-download-title1') }}</p>
          <div class="home-download-tip">
            <p class="first"><img src="../assets/images/20180815/Checkmark.png" alt=""><span>{{ $t('home-download-title2') }}</span></p>
            <p class="second"><img src="../assets/images/20180815/Checkmark.png" alt=""><span>{{ $t('home-download-title3') }}</span></p>
            <p style="display:block"></p>
            <p class="third"><img src="../assets/images/20180815/Checkmark.png" alt=""><span>{{ $t('home-download-title4') }}</span></p>
            <p class="four"><img src="../assets/images/20180815/Checkmark.png" alt=""><span>{{ $t('home-download-title8') }}</span></p>
          </div>
          <div class="home-download-ways">
            <div class="home-download-qrcode">
              <img src="../assets/images/20180815/QRCode.png" alt="">
            </div>
            <div class="home-download-others">
              <div class="gotoWeb" @click="gotoWeb">
                <img src="../assets/images/20180815/computer.png" alt="">
                <span>{{ $t('home-download-title5') }}</span>
              </div>
              <div class="gotoPC" @click="gotoPC">
                <img src="../assets/images/20180815/download.png" alt="">
                <span>{{ $t('home-download-title6') }}</span>
              </div>
            </div>
          </div>
          <!--<a class="download-ios cur decoration" href="https://itunes.apple.com/app/id1227620003"></a>-->
          <!--<a class="download-android cur decoration" href="https://www.craitapp.com/download/crait.apk"></a>-->
          <!--<a class="download-google cur decoration" href="https://play.google.com/store/apps/details?id=com.craitapp.crait"></a>-->
          <!--<a class="download-pc cur decoration" href="https://fs.craitapp.com/download/crait-setup.exe"></a>-->
        </div>
        <div class="tryCrait"><a href="https://dl.craitcorp.com/">{{ $t('home-download-title7') }}</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHost } from '../utils.js'
export default {
  metaInfo () {
    return {
      title: 'Crait | ' + this.$i18n.t('download'), // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.$i18n.t('key-content')
      },
      {
        name: 'description',
        content: this.$i18n.t('description-content')
      }]
    }
  },
  data () {
    return {
      user: navigator.userAgent,
      href: '#'
    }
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  methods: {
    gotoWeb () {
      let a = document.createElement('a')
//      a.className = 'download-img'
      a.href = '/login/index.html#/'
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
//      window.location.href = 'https://www.craitapp.com/login/index.html#/'
    },
    gotoPC () {
      let a = document.createElement('a')
//      a.className = 'download-img'
      let href = getHost('fs')
      a.href = href + '/download/crait-setup.exe'
//      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
//      window.location.href = 'https://fs.craitapp.com/download/crait-setup.exe'
    }
  }
}
</script>

<style lang="scss" scoped>
  .download {
    /*margin-top: 1.97rem;*/
    padding: 1.96rem 0 1.57rem !important;
    margin-top: 0 !important;
    background: #fafafa;
    @media screen and (max-width: 760px){
      padding:0.5rem  0 1rem!important;
    }
    .small-screen {
      display: none;
      margin-bottom: .3rem;
      @media screen and (max-width: 760px){
        display: block;
      }
      .home-title {
        font-size: 0.28rem;
      }
      .line {
        height: .04rem;
        width: 0.8rem;
        background: #E7345E;
        margin: 0.05rem auto 0;
      }
    }
    .multi-device {
      /*width: 70vw;*/
      width: 6.63rem;
      height: 4.21rem;
      /*margin-top: 0.5rem;*/
      @media screen and (max-width: 760px){
        width: 320px;
        height: 203px;
      }
    }
    .home-intro {
      .home-intro-detail {
        margin: 0.5rem auto;
        text-align: left;
      }
    }
    .download-qrcode {
      margin-top: 0.35rem;
      p {
        font-size: 0.3rem;
        color: #666;
        @media screen and (max-width: 760px) {
          font-size: 0.18rem;
          text-align: left;
          padding: 0 .1rem;
        }
      }
      img {
        margin: 0.75rem 0;
      }
    }
    .home-download {
      display: inline-block;
      /*padding: 0.5rem auto;*/
      text-align: left;
      vertical-align: top;
      margin-left: .8rem;
      @media screen and (max-width: 760px){
        margin-left: .25rem;
        display: block;
      }
      .home-title {
        display: block;
        @media screen and (max-width: 760px){
          display: none;
        }
      }
      .home-download-tip {
        margin-top: .2rem;
        p {
          display: inline-block;
          img {
            @media screen and (max-width: 760px){
              width: 0.12rem;
              height: 0.12rem;
            }
          }
          span {
            font-size: .28rem;
            color: #999;
            margin-left: .1rem;
            @media screen and (max-width: 760px){
              font-size: 0.14rem;
              margin-left: .05rem;
            }
          }
        }
        .second {
          margin-left: 1.12rem;
          @media screen and (max-width: 760px){
            margin-left: 0.49rem;
          }
        }
        .third {
          margin-top: .1rem;
        }
        .four {
             margin-left: .87rem;
            @media screen and (max-width: 760px){
              margin-left: .38rem;
            }
          }
      }
      /*a {*/
        /*display: inline-block;*/
        /*width: 2.15rem;*/
        /*height: 0.6rem;*/
        /*margin-right: 0.1rem;*/
        /*vertical-align: middle;*/
        /*@media screen and (max-width: 760px){*/
          /*margin: 0.1rem 0;*/
        /*}*/
      /*}*/
      .download-android {
        background: url("../assets/images/new/download_android@2x.png") no-repeat center;
        background-size: cover;
        /*margin-bottom: 0;*/
      }
      .download-ios {
        background: url("../assets/images/new/download_ios@2x.png") no-repeat center;
        background-size: cover;
      }
      .download-google {
        background: url("../assets/images/20180102/download_googleplay@2x.png") no-repeat center;
        background-size: cover;
      }
      .download-pc {
        background: url("../assets/images/20180102/download_win@2x.png") no-repeat center;
        background-size: cover;
      }
    }
    .home-download-ways {
      display: block;
      @media screen and (max-width: 760px){
        display: none;
      }
      margin-top: .5rem;
      > div {
        display: inline-block;
      }
      .home-download-qrcode {
        box-shadow: #888888 0 2px 20px;
        border-radius: 7px;
      }
      .home-download-others {
        margin-left: .3rem;
        vertical-align: top;
        .gotoWeb, .gotoPC {
          width: 231px;
          height: 60px;
          line-height: 60px;
          border-radius: 5px;
          cursor: pointer;
          font-size: .14rem;
          color: #fff;
          padding-left: .2rem;
          img, span {
            vertical-align: middle;
          }
          img {
            margin-right: .1rem;
          }
        }
        .gotoWeb {
          background: #43e184;
        }
        .gotoPC {
          background: #46d3ff;
          margin-top: .25rem;
        }
      }
    }
    .tryCrait {
      width: 3rem;
      height: 0.5rem;
      line-height: 0.5rem;
      font-size: 0.2rem;
      background: #5CA4EC;
      border-radius: 3px;
      margin: 0.4rem auto 0;
      font-weight: 400;
      display: none;
      text-align: center;
      @media screen and (max-width: 760px){
        display: block;
      }
      a {
        text-decoration: none;
        color: #fff;
        width: 100%;
        display: inline-block;
        height: 100%;
      }
    }
  }
  @media screen and (max-width: 760px){
    .home-part {
      padding: 0.3rem 0;
      .home-info {
        width: 95%;
        margin-bottom: 0.5rem;
        .home-title {
          font-size: 0.3rem;
        }
      }
      .home-intro {
        /*display: block;*/
        flex-direction: column-reverse;
        .tool-pic {
          padding: 0;
        }
        .home-intro-title {
          font-size: 0.2rem;
          width: 100%;
          line-height: 0.3rem;
        }
        .home-intro-detail {
          font-size: 0.16rem;
          width: 95%;
          line-height: 0.24rem;
        }
        .home-crait-advantage-intro, .secureCommunication {
          margin-left: 0.2rem;
          padding: 0;
        }
        .organization .home-intro-title {
          width: 100%;
        }
        .key-feature-lists {
          display: block;
        }
      }
      .home-intro:nth-of-type(3) {
        flex-direction: column;
      }
    }
    .download {
      .home-info {
        margin-bottom: 0;
      }
    }
  }
  .home-part {
    padding: 0.7rem 0 0;
    text-align: center;
  }
  .home-info {
    width: 70%;
    margin: 0 auto;
  }
  .home-profile {
    font-size: 0.18rem;
    /*color: #888;*/
    margin: 0.25rem auto 0;
    width: 78%;
  }
  .home-title {
    font-size: 0.5rem;
    color: #303030;
    font-weight: 600;
  }
  .home-intro {
    i {
      display: inline-block;
    }
    .home-intro-title {
      font-size: 0.4rem;
      width: 57%;
      line-height: 0.6rem;
    }
    .home-intro-detail {
      width: 67%;
      font-size: 0.3rem;
      color: #999;
      margin: 0.25rem 0 0.2rem;
      line-height: 0.42rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Download.vue?2a39fc75